import React from 'react'
import { withRouter } from 'react-router-dom'

import Container from './Container'
export default withRouter(props => (
  <Container
    missionId={props.match.params.missionId}
    cityPlanId={props.match.params.cityPlanId}
    match={props.match}
    history={props.history}
    deprecatedLocation={props.location}
    editMode={props.editMode}
  />
))



// WEBPACK FOOTER //
// ./src/Containers/Mission/index.js